import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/customer-cut-order-list',
            name: 'admin-customer-cut-order-list',
            component: () => import(/* webpackChunkName: "page-admin-customer-order-managment-cut-order-list" */ `@/page/admin/plain-order-management/cut-order-management/index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "切位订单列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "客户订单管理"
                                        },
                                        {
                                                  name: "切位订单列表"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
